import type { ContainerType } from '../ContainerComponents/ContainerPage';

export const getMissingFieldsForLabel = (containerType: ContainerType) => {
  const requiredFields = [
    'id',
    'hexCode',
    'imageUrl',
    'name',
    'sizeHelper',
    'sku',
    'packingUnit',
  ];

  return requiredFields.filter(
    (field) => !containerType[field as keyof ContainerType],
  );
};
